import { gql } from '@apollo/client';

export const ParagraphActivityPoiMapFragment = gql`
  fragment ParagraphActivityPoiMap on ParagraphActivityPoiMap {
    id
  }
`;
